'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _nitroIcon = require('../nitro-icon');

var _nitroIcon2 = _interopRequireDefault(_nitroIcon);

var _styles = require('./styles');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NitroTooltip = function (_Component) {
  _inherits(NitroTooltip, _Component);

  function NitroTooltip(props) {
    _classCallCheck(this, NitroTooltip);

    var _this = _possibleConstructorReturn(this, (NitroTooltip.__proto__ || Object.getPrototypeOf(NitroTooltip)).call(this, props));

    _this.handleClickAway = function (e) {
      if (!_this.state.visible || _this.tooltip.contains(e.target)) {
        return;
      }

      _this.close();
    };

    _this.handleClick = function () {
      _this.toggle();
    };

    _this.open = function () {
      _this.setState({
        visible: true
      });
    };

    _this.toggle = function () {
      _this.setState({
        visible: !_this.state.visible
      });
    };

    _this.close = function () {
      _this.setState({
        visible: false
      });
    };

    _this.state = {
      visible: false
    };
    return _this;
  }

  _createClass(NitroTooltip, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      document.addEventListener('click', this.handleClickAway);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      document.removeEventListener('click', this.handleClickAway);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          children = _props.children,
          icon = _props.icon,
          width = _props.width,
          position = _props.position,
          triggerComponent = _props.triggerComponent;


      return _react2.default.createElement(
        _styles.TooltipWrapper,
        {
          innerRef: function innerRef(c) {
            _this2.tooltip = c;
          }
        },
        _react2.default.createElement(
          _styles.Trigger,
          {
            onClick: this.handleClick
          },
          triggerComponent || _react2.default.createElement(_nitroIcon2.default, {
            name: icon,
            size: 15
          })
        ),
        _react2.default.createElement(
          _styles.Tooltip,
          {
            width: width,
            position: position,
            visible: this.state.visible
          },
          _react2.default.createElement(
            _styles.ContentWrapper,
            null,
            children,
            _react2.default.createElement(_styles.Arrow, { position: position })
          )
        )
      );
    }
  }]);

  return NitroTooltip;
}(_react.Component);

NitroTooltip.propTypes = {
  children: _propTypes2.default.node,
  icon: _propTypes2.default.string,
  position: _propTypes2.default.oneOf(['left', 'right', 'bottom', 'top']),
  triggerComponent: _propTypes2.default.node,
  width: _propTypes2.default.string
};

NitroTooltip.defaultProps = {
  icon: 'others-circle',
  position: 'right',
  width: '300px'
};

exports.default = NitroTooltip;


//////////////////
// WEBPACK FOOTER
// ./~/nitro-components/build/nitro/nitro-tooltip/NitroTooltip.js
// module id = 3050
// module chunks = 4